import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractCaseTransformations from "./abstractCaseTransformations";

const divorceTransformations: FormTransformations = {
  dateFields: [
    ...(abstractCaseTransformations.dateFields || []),
    { path: "dateMovedOut", type: "date" },
    { path: "dateSeparation", type: "date" },
    { path: "dateMarriage", type: "date" },
    { path: "powerOfAttorney", type: "dateTime" },
    { path: "installmentRateOverdueSince", type: "date" },
    { path: "courtFeeInvoiceReceivedDate", type: "date" },
    { path: "courtFeePaidDate", type: "date" },
    { path: "processCostSupportVerified", type: "date" },
    { path: "courtDate.appointmentDate", type: "date" },
    { path: "verification", type: "dateTime" },
  ],
  numberFields: [
    ...(abstractCaseTransformations.numberFields || []),
    "leadStatus",
    "applicationStatus",
    "numberPensions",
    "numberPensionsPartner",
    "numberChildren",
    "netIncomePetitioner",
    "netIncomePartner",
    "responsibleCourt.advoAssistId",
  ],
  timeFields: [...(abstractCaseTransformations.timeFields || []), "courtDate.appointmentTime"],
  floatFields: [...(abstractCaseTransformations.floatFields || []), "valueInDisputeReal"],
  ibanFields: abstractCaseTransformations.ibanFields,
};
export default divorceTransformations;
